import React from "react";
import { Route, Switch } from "react-router-dom";
import ExpensesTable from "./ExpensesTable";
import ExpensesTasksTable from "./ExpensesTasksTable";
import ExpensesForm from "./ExpensesForm";
import ExpenseTasksForm from "./ExpenseTasksForm";
import WriteRoute from "../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route exact path="/expenses/expenses" component={ExpensesTable} />
    <Route exact path="/expenses/expensetasks" component={ExpensesTasksTable} />
    <WriteRoute
      exact
      path="/expenses/expenses/addnew"
      component={ExpensesForm}
      redirectTo="/expenses/expenses"
    />
    <WriteRoute
      exact
      path="/expenses/expensetasks/addnew"
      component={ExpenseTasksForm}
      redirectTo="/expenses/expensetasks"
    />
  </Switch>
);
